<template>
  <section class="website-section content-wrapper" v-if="isLoaded">
    <app-header></app-header>
    <content-row v-for="(row,index) in content" :content="content" :index="index" :row="row" :key="row.id">
    </content-row>
  </section>
</template>
<script>
  import ContentRow from './ContentRow.vue'
  import appHeader from '../layout/Header.vue'

  export default {
    data () {
      return {
        isLoaded: false,
        content: {}
      }
    },
    methods: {
      getData (slug) {
        this.isLoaded = false
        this.axios.get('/sections/view?slug=' + slug)
          .then(response => {
            this.content = response.data.section.content
            this.isLoaded = true
            document.title = response.data.section.title ? response.data.section.title + ' - ' + this.$store.getters.settings.appName : this.$store.getters.settings.appName
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    created () {
      this.getData(this.$route.params.slug)
    },
    components: {
      appHeader,
      ContentRow
    },
    watch: {
      '$route' (to, from) {
        this.getData(to.params.slug)
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/Section.vue